import { useEffect } from 'react';

const StructuredData = ({ project }) => {
  useEffect(() => {
    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Paca News",
      "url": "https://pacanews.evocore.cloud",
      "logo": "https://pacanews.evocore.cloud/logo512.png",
      "description": "Média d'actualité locale pour la région Provence-Alpes-Côte d'Azur",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Provence-Alpes-Côte d'Azur",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "43.7102",
        "longitude": "7.2620"
      },
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "43.7102",
          "longitude": "7.2620"
        },
        "geoRadius": "100000"
      },
      "sameAs": [
        "https://www.linkedin.com/company/pacanews",
        "https://twitter.com/pacanews"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "email": "contact@pacanews.fr",
        "telephone": "+33745061070",
        "availableLanguage": ["French"]
      }
    };

    // LocalBusiness Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Paca News",
      "image": "https://pacanews.evocore.cloud/logo512.png",
      "description": project?.description || "Actualité de la région PACA",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Provence-Alpes-Côte d'Azur",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "43.7102",
        "longitude": "7.2620"
      },
      "url": "https://pacanews.evocore.cloud",
      "telephone": "+33745061070",
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      }
    };

    // SoftwareApplication Schema
    const softwareSchema = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Paca News",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR"
      },
      "description": "Plateforme d'actualité pour la région Provence-Alpes-Côte d'Azur",
      "featureList": [
        "Actualités locales",
        "Projets innovants",
        "Écosystème entrepreneurial",
        "French Tech PACA"
      ],
      "screenshot": "https://pacanews.evocore.cloud/screenshot.png"
    };

    // WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Paca News",
      "url": "https://pacanews.evocore.cloud",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://pacanews.evocore.cloud/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": "https://pacanews.evocore.cloud"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Projet",
          "item": "https://pacanews.evocore.cloud/#projet"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Contact",
          "item": "https://pacanews.evocore.cloud/#contact"
        }
      ]
    };

    // Combine all schemas
    const allSchemas = [
      organizationSchema,
      localBusinessSchema,
      softwareSchema,
      websiteSchema,
      breadcrumbSchema
    ];

    // Remove existing script if any
    const existingScript = document.getElementById('structured-data');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new script
    const script = document.createElement('script');
    script.id = 'structured-data';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(allSchemas);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('structured-data');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [project]);

  return null;
};

export default StructuredData;
